import './styles/index.less';
import {decodeQueryString, buildQuery} from "../../../core/utils/location";
import {registerGlobalFunctions} from "../common/global_functions";

export function init(options) {
    const o = {
        sId: null,
        items: [],
        fieldDescriptors: [],
        ...options
    };

    registerGlobalFunctions();
    renderTable(getReferenceItemIndex(o.sId, o.items), o.items, o.fieldDescriptors);
    initRadioButtons(o.items, o.fieldDescriptors);
    initDeleteButtons();
    initCompareSelectedButton();
}

function renderTable(referenceItemIndex, items, fieldDescriptors) {
    const referenceItem = items[referenceItemIndex];
    const $table = $('.comparison-tbl');
    const $header = $('<tr><th class="stub-cell"></th></tr>');
    const $footer = $('<tr class="comparison-footer"><td class="stub-cell"></td></tr>');
    let $row;

    $table.empty();

    items.forEach((item, index) => {
        const imgUrl = item.main_image_url !== null ? item.main_image_url.replace('{size}', 'Small') : false;
        const imgDivTemplate = imgUrl ? `<div class="car-image" style="background-image: url('${imgUrl}')"></div>` : '';
        $header.append(`<th>
                ${imgDivTemplate}
                <div class="make-and-model">${item.make_and_model}</div>
                <div class="car-type">${item.car_type}</div>
                <div class="current-highest-bid">${item.current_highest_bid} &euro;</div>
                <div class="controls-container">
                    <input class="reference-radio" name="reference" type="radio"
                        ${index == referenceItemIndex ? 'checked' : ''} data-index="${index}" />
                    <input class="selection-checkbox" type="checkbox" data-id="${item.id}" />
                    <span class="controls-separator"></span>
                    <div class="delete-button" data-id="${item.id}"></div>
                </div>
            </th>`);
        $footer.append(`<td>
                <div>${item.id}</div>
                <div>${item.lease_plan_entity}</div>
                <div>Дата завершения: ${item.auction_end_date_time}</div>
                <div><a href="${item.report_url}" target="_blank" rel="nofollow noopener">Отчёт</a></div>
                <div>
                    <a
                        href="https://leaseplanauctions.com/#LotDetails/?AuctionId=${item.auction_id}&VehicleId=${item.id}"
                        target="_blank"
                        rel="nofollow noopener"
                    >На сайте</a>
                </div>
            </td>`);
    });

    $table.append($header);

    fieldDescriptors.forEach(descriptor => {
        $row = $(`<tr><td class="feature-name"><div>${descriptor.name}</div></td></tr>`);

        items.forEach((item, index) => {
            const equalityEps = descriptor.equequality_eps || 0;
            const similarityEps = descriptor.similarity_eps || 0;
            const isBool = descriptor.is_bool == '1';
            const cellText = item[descriptor.key] !== undefined
                ? (isBool
                    ? 'Есть' : (item[descriptor.key].formatter !== undefined
                        ? window[item[descriptor.key].formatter](item, '?')
                        : item[descriptor.key].name))
                : (isBool ? 'Нет' : '?');
            let cellClass = 'white';
            if(index !== referenceItemIndex) {
                const val = item[descriptor.key] !== undefined
                    ? (isBool ? 1 : item[descriptor.key].weight)
                    : 0;
                const rVal = referenceItem[descriptor.key] !== undefined
                    ? (isBool ? 1 : referenceItem[descriptor.key].weight)
                    : 0;

                const delta = val - rVal;

                if(Math.abs(delta) <= equalityEps) {
                    cellClass = 'yellow';
                } else if(delta > 0) {
                    if(delta <= similarityEps) {
                        cellClass = 'lime';
                    } else {
                        cellClass = 'green';
                    }
                } else if(delta < 0) {
                    if(delta >= -similarityEps) {
                        cellClass = 'orange';
                    } else {
                        cellClass = 'red';
                    }
                }

            }

            $row.append(`<td class="${cellClass}">${cellText}</td>`);
        });

        $table.append($row);
    });

    $table.append($footer);
}

function getReferenceItemIndex(id, items) {
    const count = items.length;
    let result = 0;

    for(let i = 0; i < count; i++) {
        if(items[i].id == id) {
            result = i;
            break;
        }
    }

    return result;
}

function initRadioButtons(items, fieldDescriptors) {
    $('.comparison-tbl').on('click', '.reference-radio', e => {
        const index = $(e.target).data('index');
        renderTable(index, items, fieldDescriptors);
    });
}

function initDeleteButtons() {
    $('.comparison-tbl').on('click', '.delete-button', e => {
        const id = $(e.target).data('id');
        const urlParts = window.location.href.split('?');
        const getParams = decodeQueryString(urlParts[1]);

        if(getParams.s_id !== undefined && getParams.s_id == id) {
            delete getParams.s_id;
        }

        getParams.ids = getParams.ids.split(',').filter(item => item != id).join(',');

        window.location = buildComparisonQuery(getParams);
    });
}

function initCompareSelectedButton() {
    const $compareSelectedBtn = $('#compare-selected-btn');

    $('.comparison-tbl').on('change', '.selection-checkbox', e => {
        $compareSelectedBtn.prop('disabled', $('.selection-checkbox:checked').length === 0);
    });

    $compareSelectedBtn.click(e => {
        const checkedIds = [];

        $('.selection-checkbox:checked').each((index, element) => checkedIds.push($(element).data('id')));

        if(checkedIds.length) {
            const urlParts = window.location.href.split('?');
            const getParams = decodeQueryString(urlParts[1]);

            if(getParams.s_id !==  undefined && checkedIds.indexOf(parseInt(getParams.s_id)) === -1) {
                delete getParams.s_id;
            }

            getParams.ids = checkedIds.join(',');

            window.location = buildComparisonQuery(getParams);
        }
    });
}

function buildComparisonQuery(params) {
    return window.location.href.split('?')[0] + '?' + buildQuery(params).replace(/%2C/g, ',');
}


// WEBPACK FOOTER //
// ./modules/car_auctions/comparison/index.js